class PlatformTypeModel {
    static NORMAL = 0;
    static MOVING = 1;
    static CRUSHER = 2;
    static DEBUG = 3;
    static BULLET = 4;
}

export default PlatformTypeModel
